<template>
  <button :class="(this.customColor?this.customColor+' ':'')+'button button-secondary'+(this.fullWidth?' full-width':'')"
          :disabled="!!this.disabled"
  >
    {{ text }}
  </button>
</template>

<style scoped>
.button-secondary {
  background: none;
  color: var(--ink);
  border: 1px solid var(--border-strong);
}

.button-secondary:hover:not(:disabled) {
  background-color: var(--surface-muted);
}

.button-secondary.red {
  border-color: var(--error);
  color: var(--error);
}

.button-secondary:disabled, .button-secondary.red:disabled {
  border-color: var(--disabled-grey);
  color: var(--disabled-grey);
  cursor: not-allowed;
}
</style>

<script>
export default {
  props: [
    "text",
    "customColor",
    "disabled",
    "fullWidth",
  ],
}
</script>